import { api } from "@/utils/api";

export interface WorkItemTemplate {
  id: string;
  companyId: string;
  departmentId: string;
  name: string;
  description?: string | null;
  executionOrder: number;
  isActive: boolean;
}

export interface WorkItemTemplateCreate {
  name: string;
  description?: string | null;
  executionOrder?: number;
  isActive?: boolean;
}

export interface WorkItemTemplateUpdate {
  name?: string;
  description?: string | null;
  executionOrder?: number;
  isActive?: boolean;
}

export const workItemTemplateApi = {
  getByDepartment: async (departmentId: string, includeInactive = false) => {
    const response = await api.get<WorkItemTemplate[]>(
      `/api/departments/${departmentId}/work-items`,
      {
        params: { includeInactive },
      }
    );
    return response.data;
  },

  createBulk: async (departmentId: string, data: WorkItemTemplateCreate[]) => {
    const response = await api.post<WorkItemTemplate[]>(
      `/api/departments/${departmentId}/work-items`,
      data
    );
    return response.data;
  },

  update: async (
    departmentId: string,
    workItemId: string,
    data: WorkItemTemplateUpdate
  ) => {
    const response = await api.put<WorkItemTemplate>(
      `/api/departments/${departmentId}/work-items/${workItemId}`,
      data
    );
    return response.data;
  },

  delete: async (departmentId: string, workItemId: string) => {
    const response = await api.delete(
      `/api/departments/${departmentId}/work-items/${workItemId}`
    );
    return response.data;
  },
};
